








































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import number from '@/modules/shared/filters/number.filter.ts';


@Component({
    name: 'reward-card',
    computed: {
        ...mapGetters({
            getReward: 'getReward',
            getRewardCategory: 'getRewardCategory',
            pointsReamining: 'getRemainingPoints',
        }),
    },
    filters: {
        number,
    },
})
export default class RewardCard extends Vue {
    @Prop() private rewardId!: string;


    private secctionSelected = 'info';
    private getReward!: any;
    private getRewardCategory!: any;
    private pointsReamining!: number;


    get reward() {
        return this.getReward(this.rewardId);
    }

    get extraPoints() {
        return Math.round(this.reward.requiredPoints - this.pointsReamining);
    }

    get canBuy() {
        return this.reward.requiredPoints <= this.pointsReamining;
    }

    get rewardCategory() {
        let categoryName = '';
        const category = this.getRewardCategory(this.reward.category);
        if ( category ) {
            categoryName = category.name;
        }
        return categoryName;
    }


    private buy() {
        this.$emit('buy-reward', this.rewardId);
    }

}
